import React, { useState, useEffect } from "react"
import { collection, addDoc, getDocs } from "firebase/firestore"
import { db } from "../../Firebase/config"
import Modal from "react-modal"
import ReactSelect from "react-select"
import "../../Styles/Reservation.css"

const PromoCodesPage = () => {
  const [promoCodes, setPromoCodes] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [users, setUsers] = useState([])
  const [promoData, setPromoData] = useState({
    name: "",
    expiryDate: "",
    discountType: "percentage",
    discountValue: "",
    specificUser: "",
    minAmount: "",
    userId: "",
  })

  useEffect(() => {
    const fetchPromoCodes = async () => {
      const querySnapshot = await getDocs(collection(db, "Promocodes"))
      setPromoCodes(
        querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      )
    }
    fetchPromoCodes()
  }, [])

  useEffect(() => {
    const fetchUsers = async () => {
      const querySnapshot = await getDocs(collection(db, "DeliveryUsers"))
      setUsers(
        querySnapshot.docs.map((doc) => ({ id: doc.id, name: doc.data().name }))
      )
    }
    fetchUsers()
  }, [])

  const handleChange = (selectedOption, { name }) => {
    setPromoData({ ...promoData, [name]: selectedOption.value })
  }

  const handleUserSelection = (selectedOption) => {
    setPromoData({
      ...promoData,
      userId: selectedOption ? selectedOption.value : "",
    })
  }

  const handleSubmit = async () => {
    await addDoc(collection(db, "Promocodes"), promoData)
    setIsModalOpen(false)
  }

  const discountOptions = [
    { value: "percentage", label: "Percentage" },
    { value: "amount", label: "Fixed Amount" },
  ]
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
  }

  return (
    <div className="dashboard-container">
      <main className="main-content">
        <header className="header">
          <input
            type="text"
            placeholder="Search by code name..."
            value={searchQuery}
            onChange={handleSearchChange}
            className="search-box"
          />

          <button className="btns-Admin" onClick={() => setIsModalOpen(true)}>
            + Add Promo Code
          </button>
        </header>

        <section className="orders-table">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Expiry Date</th>
                <th>Discount</th>
                <th>Applicable For</th>
              </tr>
            </thead>
            <tbody>
              {promoCodes.map((promo) => (
                <tr key={promo.id}>
                  <td>{promo.name}</td>
                  <td>{promo.expiryDate}</td>
                  <td>
                    {promo.discountType === "percentage"
                      ? `${promo.discountValue}%`
                      : `${promo.discountValue} EGP`}
                  </td>
                  <td>{promo.userId ? "Specific User" : "Everyone"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
      </main>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setIsModalOpen(false)}
        contentLabel="Add Promo Code"
        className="modal-content-promo"
        overlayClassName="modal-overlay-promo"
      >
        <h2>Create Promo Code</h2>
        <input
          type="text"
          name="name"
          placeholder="Promo Name"
          onChange={(e) => setPromoData({ ...promoData, name: e.target.value })}
          className="form-input-promo"
        />
        <input
          type="date"
          name="expiryDate"
          onChange={(e) =>
            setPromoData({ ...promoData, expiryDate: e.target.value })
          }
          className="form-input-promo"
        />

        <ReactSelect
          options={discountOptions}
          onChange={handleChange}
          name="discountType"
          placeholder="Select Discount Type"
          className="select-role-promo"
        />

        <input
          type="number"
          name="discountValue"
          placeholder="Discount Value"
          onChange={(e) =>
            setPromoData({ ...promoData, discountValue: e.target.value })
          }
          className="form-input-promo"
        />
        {promoData.discountType === "amount" && (
          <input
            type="number"
            name="minAmount"
            placeholder="Min Order Amount"
            onChange={(e) =>
              setPromoData({ ...promoData, minAmount: e.target.value })
            }
            className="form-input-promo"
          />
        )}

        <ReactSelect
          options={[
            { value: "", label: "Everyone" },
            ...users.map((user) => ({ value: user.id, label: user.name })),
          ]}
          onChange={handleUserSelection}
          placeholder="Select User (Optional)"
          className="select-user-promo"
        />

        <button onClick={handleSubmit} className="btn-save-promo">
          Save
        </button>
        <button
          onClick={() => setIsModalOpen(false)}
          className="btn-close-promo"
        >
          Close
        </button>
      </Modal>
    </div>
  )
}

export default PromoCodesPage
